import { useMemo } from "react";
import type {
  ComponentProps,
  ModelsInstitutionalProductCard,
} from "../../../../types";
import {
  InstitutionalProductCardVariantProps,
  institutionalProductCardVariants,
} from "./institutional-product-card.variants";

export type useInstitutionalProductCardProps = ComponentProps<
  ModelsInstitutionalProductCard,
  InstitutionalProductCardVariantProps
> & {
  index: number;
};

export const useInstitutionalProductCard = (
  props: useInstitutionalProductCardProps
) => {
  const { className = "", theme = "dark", data, index } = props;

  const styles = useMemo(
    () =>
      institutionalProductCardVariants({
        theme,
      }),
    [theme]
  );

  return {
    theme,
    className,
    data,
    styles,
    index,
  };
};
